<div class='container-lg pt-4 h-83 overflow-hidden'>
  <div class='row h-100'>

    <div class='col-8 h-100' id='test-list'>
      <div class='row my-2 pt-1 d-flex align-items-center'>
        <mat-form-field appearance='fill' class='mx-2 col-2'>

          <mat-label>Test Types</mat-label>
          <mat-select #typeSelect (selectionChange)='filterTestTypes($event)' [formControl]='testTypes'
                      id='testTypesSelect'
                      multiple>
            <mat-select-trigger>
              {{testTypes.value ? testTypes.value[0] : ''}}
              <span *ngIf='testTypes.value?.length > 1' class='additional-selection'>
        (+{{testTypes.value.length - 1}} {{testTypes.value?.length === 2 ? 'other' : 'others'}})
      </span>
            </mat-select-trigger>
            <mat-option *ngFor='let testType of testTypesList' [value]='testType'>{{testType}}</mat-option>
          </mat-select>
        </mat-form-field>
        <div class='col-5 d-flex'>
          <mat-form-field class='border-top-0 mx-2 w-50'>
            <mat-label>Start date:</mat-label>
            <input matInput type='date' (change)='handleStartDateChange($event)' id='start'
                   class='filters-input mb-2' name='date-start'>
          </mat-form-field>
          <mat-form-field class='border-top-0 mx-2 w-50'>

            <mat-label>End date:</mat-label>

            <input matInput type='date' id='end' (change)='handleEndDateChange($event)' class='filters-input mb-2'
                   name='date-end'>
          </mat-form-field>
        </div>
        <button class='btn btn-link mb-3 col-1' (click)='clearFilters()'><small>Clear Filters</small></button>
      </div>
      <div class='row d-flex justify-content-between list-container'>
        <h2 class='card-title'
            *ngIf='userSavedPlaces && loaded'>Location Details</h2>
        <h2 class='card-title'
            [hidden]='userSavedPlaces && loaded'>Loading Location Details...</h2>
        <div class='button-group' *ngIf='userSavedPlaces && loaded'>
          <button data-toggle='modal' data-target='#geotagModal'
                  class='btn test-detail-button d-inline-flex align-items-center mr-2 mb-1 mb-lg-0'>
            Custom Geotag
          </button>
          <button data-toggle='modal' data-target='#emailModal'
                  class='btn test-detail-button d-inline-flex align-items-center mr-2 mb-1 mb-lg-0'>
            <img src='../../../assets/EmailVector.png' height='12'
                 class='mr-2'
                 width='14'/>Email
          </button>
          <button (click)='createLocationPDF()' class='btn test-detail-button d-inline-flex align-items-center'>
            <img
              class='mr-2'
              src='../../../assets/DLVector.png' height='12' width='10'/>Download All
          </button>
        </div>
      </div>
      <div class='row my-3 list-container'>
        <div class='pointer-cursor w-100'>
          <div class='d-flex justify-content-between'>
            <div class='text-primary font-weight-bold'>
              <i class='fas fa-map-marker-alt mx-1'></i>
              {{place?.formatted_address || place?.name}}
            </div>
          </div>
          <hr>
          <div class='row mb-3'>
            <div class='col-6 col-md-4 col-xl-3'>
              <small>NUMBER OF TESTS</small>

              <div class='text-capitalize font-16'>{{place?.numberOfTests}}</div>
            </div>
            <div class='col-6 col-md-4 col-xl-3'>
              <small>NUMBER OF WATER SOURCES</small>
              <div class='font-16 pointer-cursor'>
                {{place?.numberOfSources}}

              </div>
            </div>
            <div class='col-6 col-md-4 col-xl-3'>

              <small>LAST TESTED</small>
              <div class='text-capitalize font-16 pointer-cursor'>

                {{place?.lastTested}}
              </div>


            </div>
          </div>

        </div>


      </div>


      <div class='row my-2'>
        <div class='list-container w-100' [hidden]='loaded'>
          <div class='row'>
            <div class='col-12 col-lg-6 pb-2'>
              <small class='d-block'>DATE & TIME</small>
              <ngx-skeleton-loader count='1' [theme]="{
          'width': '75%'
        }"></ngx-skeleton-loader>

            </div>
            <div class='col-12 col-lg-6 pb-2'>
              <small class='d-block'>TEST ID</small>
              <ngx-skeleton-loader count='1' [theme]="{
          'width': '75%'
        }"></ngx-skeleton-loader>

            </div>
          </div>
          <div class='row'>
            <div class='col-12 col-lg-6 dropdown-container pb-2'>
              <small class='d-block'>LOCATION</small>
              <ngx-skeleton-loader count='1' [theme]="{
          'width': '75%'
        }"></ngx-skeleton-loader>

            </div>
            <div class='col-12 col-lg-6 dropdown-container pb-2'>
              <small class='d-block'>WATER SOURCE</small>
              <ngx-skeleton-loader count='1' [theme]="{
          'width': '75%'
        }"></ngx-skeleton-loader>


            </div>
          </div>
          <div class='row'>
            <div class='col-12 col-lg-6 pb-2'>
              <small class='d-block'>DEVICE ID</small>
              <ngx-skeleton-loader count='1' [theme]="{
          'width': '75%'
        }"></ngx-skeleton-loader>

            </div>
            <div class='col-12 col-lg-6 pb-2'>
              <small class='d-block'>RESULTS</small>
              <ngx-skeleton-loader count='1' [theme]="{
          'width': '75%'
        }"></ngx-skeleton-loader>

            </div>
          </div>
          <div class='row'>
            <div class='col-12'>
              <small class='d-block'>NOTES</small>
              <ngx-skeleton-loader count='1' [theme]="{
          'width': '100%'
        }"></ngx-skeleton-loader>


            </div>
          </div>

        </div>

        <div class='w-100 pt-2 d-flex justify-content-center align-items-center'
             *ngIf='loaded && !testsToDisplay[0]'>No matching tests found.
        </div>

        <app-test-details-card class='w-100 mb-2' *ngFor='let test of testsToDisplay' [headerNeeded]='false'
                               [locationEditNeeded]='false' [footerNeeded]='true' [apiUid]='uid' [selectedItem]='test'
                               [idToken]='idToken' (updateDataEvent)='getUserSavedData()' [hidden]='!loaded'
                               [locationHeaderNeeded]='true'
                               [userSavedWaterSources]='userSavedWaterSources'></app-test-details-card>
      </div>
    </div>


    <div class='col-4 pr-2 h-100' [hidden]='!loaded' id='map-container'>
      <google-map
        height='100%'
        width='auto'
        class='pr-2'
        [zoom]='15'
        [center]='{lat:place?.lat, lng: place?.lng}'>
        <map-marker
          #markerElem='mapMarker'
          [id]='place?.place_id'
          [position]='position'
          [options]='markerOptions'>

        </map-marker>
      </google-map>
    </div>
  </div>
</div>

<!-- Email Modal -->
<div class='modal fade' id='emailModal' tabindex='-1' role='dialog' aria-labelledby='modalTitle'
     aria-hidden='true'>
  <app-email-template [placeTests]='testsToDisplay' [email]='email' [location]='place'
                      [idToken]='idToken'></app-email-template>
</div>

<!-- Geotag Modal -->
<div class='modal fade' id='geotagModal' tabindex='-1' role='dialog' aria-labelledby='modalTitle'
     aria-hidden='true'>
  <app-geotag-modal *ngIf='loaded && place' [location]='place' [idToken]='idToken' [uid]='this.uid' (updateMap)='updateMap()'></app-geotag-modal>
</div>
